import React from "react";
import { MailOpen, Mail } from "lucide-react";

import { formatMelbourneDateTime } from "../../../utils/melbourneTime";

/**
 * Read receipt for a sent proposal (CG QA, 26 Oct): "Opened · <when>" once the
 * vendor has opened it, "Not opened yet" while it is waiting. The tooltip adds
 * the last open and how many times it was opened. Drafts show nothing.
 */
const ReadReceiptBadge = ({ proposal, large = false }) => {
  if (!proposal || proposal.status === "draft") return null;
  const size = large ? "text-xs px-2.5 py-1" : "text-[11px] px-2 py-0.5";
  if (!proposal.first_viewed_at) {
    return (
      <span className={`inline-flex items-center gap-1 rounded-full font-bold bg-gray-100 text-gray-500 ${size}`}>
        <Mail className="w-3 h-3" /> Not opened yet
      </span>
    );
  }
  const count = proposal.view_count || 1;
  const tip = `First opened ${formatMelbourneDateTime(proposal.first_viewed_at)}`
    + (proposal.last_viewed_at ? ` · last opened ${formatMelbourneDateTime(proposal.last_viewed_at)}` : "")
    + ` · opened ${count} time${count === 1 ? "" : "s"}`;
  return (
    <span title={tip} className={`inline-flex items-center gap-1 rounded-full font-bold bg-[#e6f6f8] text-[#0f8d9b] ${size}`}>
      <MailOpen className="w-3 h-3" /> Opened · {formatMelbourneDateTime(proposal.last_viewed_at || proposal.first_viewed_at)}
      {count > 1 ? ` (${count}×)` : ""}
    </span>
  );
};

export default ReadReceiptBadge;
